import { AiFillPhone } from "react-icons/ai";
import { HiMail } from "react-icons/hi";
import { useAppSelector } from "../../redux/store";
import { Box, Button, Grid, Paper, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useRequireAuth } from "../../hooks/require_auth";

function UserCard() {
  const { customer } = useAppSelector((state) => state.customer);

  const navigate = useNavigate();
  const { requireAuth } = useRequireAuth();

  return customer ? (
    <Paper sx={{ padding: "10px", backgroundColor: "#f8fdfe" }}>
      <Grid
        container
        direction="row"
        alignItems="center"
        justifyContent="center"
      >
        <Grid>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              fontSize: "25px",
              fontWeight: "bold",
              marginBottom: "5px",
            }}
          >
            {/* <FaUser size={20} style={{ marginRight: "5px" }} /> */}
            {customer.name}
          </Box>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              fontSize: "13px",
              marginBottom: "5px",
            }}
          >
            <AiFillPhone size={20} style={{ marginRight: "5px" }} />
            {customer.phone}
          </Box>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              fontSize: "13px",
            }}
          >
            <HiMail size={20} style={{ marginRight: "5px" }} />
            {customer.email}
          </Box>
        </Grid>
        <Box sx={{ flexGrow: 1 }} />
        <Grid>
          <Button
            onClick={() => {
              navigate("/editProfile");
            }}
          >
            Edit
          </Button>
        </Grid>
      </Grid>
    </Paper>
  ) : (
    <Paper sx={{ padding: "16px", backgroundColor: "#f8fdfe" }}>
      <Typography sx={{ fontSize: "18px", fontWeight: "bold" }}>
        Guest User
      </Typography>
      <Typography sx={{ color: "gray", marginTop: "4px" }}>
        Login to view your orders, addresses, and profile details.
      </Typography>
      <Button
        sx={{ marginTop: "10px" }}
        variant="outlined"
        onClick={() => requireAuth()}
      >
        Login
      </Button>
    </Paper>
  );
}
export default UserCard;
